import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { NewHireEdit } from '../../modules/NewHire/components/NewHireEdit';
import { newHireDashboardCheck } from '../../tools/permissionChecks';

export const Route = createFileRoute('/hrDashboard/newHire/edit/$newHireId')({
  component: RouteComponent,
  params: z.object({
    newHireId: z.coerce.number().positive(),
  }),
  loader(ctx) {
    const permissionCheck = newHireDashboardCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to edit new hires. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'HR Dashboard - New Hire Edit' }],
    };
  },
});

function RouteComponent() {
  const params = Route.useParams();
  return <NewHireEdit newHireId={params.newHireId} />;
}
